export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Côte d'Ivoire",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini (fmr. 'Swaziland')",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  ,
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const phoneCode = [
  "376",
  "244",
  "1264",
  "1268",
  "54",
  "374",
  "297",
  "61",
  "43",
  "994",
  "1242",
  "973",
  "880",
  "1246",
  "375",
  "32",
  "501",
  "229",
  "1441",
  "975",
  "591",
  "387",
  "267",
  "55",
  "673",
  "359",
  "226",
  "257",
  "855",
  "237",
  "1",
  "238",
  "1345",
  "236",
  "56",
  "86",
  "57",
  "269",
  "242",
  "682",
  "506",
  "385",
  "53",
  "90392",
  "357",
  "42",
  "45",
  "253",
  "1809",
  "1809",
  "593",
  "20",
  "503",
  "240",
  "291",
  "372",
  "251",
  "500",
  "298",
  "679",
  "358",
  "33",
  "594",
  "689",
  "241",
  "220",
  "7880",
  "49",
  "233",
  "350",
  "30",
  "299",
  "1473",
  "590",
  "671",
  "502",
  "224",
  "245",
  "592",
  "509",
  "504",
  "852",
  "36",
  "354",
  "91",
  "62",
  "98",
  "964",
  "353",
  "972",
  "39",
  "1876",
  "81",
  "962",
  "7",
  "254",
  "686",
  "850",
  "82",
  "965",
  "996",
  "856",
  "371",
  "961",
  "266",
  "231",
  "218",
  "417",
  "370",
  "352",
  "853",
  "389",
  "261",
  "265",
  "60",
  "960",
  "223",
  "356",
  "692",
  "596",
  "222",
  "269",
  "52",
  "691",
  "373",
  "377",
  "976",
  "1664",
  "212",
  "258",
  "95",
  "264",
  "674",
  "977",
  "31",
  "687",
  "64",
  "505",
  "227",
  "234",
  "683",
  "672",
  "670",
  "47",
  "968",
  "680",
  "507",
  "675",
  "595",
  "51",
  "63",
  "48",
  "351",
  "1787",
  "974",
  "262",
  "40",
  "7",
  "250",
  "378",
  "239",
  "966",
  "221",
  "381",
  "248",
  "232",
  "65",
  "421",
  "386",
  "677",
  "252",
  "27",
  "34",
  "94",
  "290",
  "1869",
  "1758",
  "249",
  "597",
  "268",
  "46",
  "41",
  "963",
  "886",
  "7",
  "66",
  "228",
  "676",
  "1868",
  "216",
  "90",
  "7",
  "993",
  "1649",
  "688",
  "256",
  "44",
  "380",
  "971",
  "598",
  "7",
  "678",
  "379",
  "58",
  "84",
  "84",
  "84",
  "681",
  "969",
  "967",
  "260",
  "263",
];
